import { useContext } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "./Breadcrumb";
import { RouteContext } from "../../contexts/RoutesContext";
import { AppContext } from "../../contexts/AppContext";
import { UserType } from "../Variables";

export function BreadcrumbBar() {
    const rc = useContext(RouteContext);
    const app = useContext(AppContext);

    let breadcumbs = rc.routes.map(x => { return <Breadcrumb key={`BreadcrumbContainer_${x.name}`} name={x.name} route={x.route} forceReload={x.forceReload} /> })

    return (
        <>
            <div className="breadcrumb-bar bg-white align-content-center ps-2 pe-2">
                <div className="container-xxl">
                    <Link to={`${app.userLoggedIn && app.loggedInUser.UserType == UserType.Candidate ? ("/home") : ""}`}><i className="fa-solid fa-house"></i> Home</Link> {breadcumbs}
                </div>
            </div>
        </>
    );
}